const typeContent = {
  pdf: {
    event: "click-download",
    eventDetail: "PDF",
  },
  video: {
    event: "click-video",
    eventDetail: "Play",
  },
  podcast: {
    event: "click-podcast",
    eventDetail: "Play",
  },
};

export function pushData(eventType, url, title, ctaLabel) {
  window.digitalData.push({
    event: typeContent[eventType].event,
    pageEvent: {
      eventInfo: {
        eventDetail: typeContent[eventType].eventDetail,
        contentTitle: title,
        contentURL: url,
        ...(ctaLabel ? { ctaLabel } : {}),
      },
    },
  });
}
